"use client";

import { useTranslations } from "next-intl";

export const NFTCardEmpty = () => {
  const t = useTranslations("nft");
  return (
    <div className="flex items-center justify-center">
      <p className="text-text-secondary text-sm font-medium">
        {t("empty.message")}
      </p>
    </div>
  );
};
